export function sortOptions(e1, e2) {
    return e1.label.toLowerCase() > e2.label.toLowerCase() ? 1 : -1;
}
